import { IListType } from "src/@redux/store";
import commonDataAccess from "../commonDataAccess";
import { IFilter } from "src/@redux/listRedux";

class SiteDataAccess {
  getSiteDropdown(arg0: boolean) {
    return commonDataAccess
      .getData("site/get/site-dropdownbycaitemId")
      .then((res) => res);
  }
  deleteCertificate(id: any) {
    return commonDataAccess
      .deleteData("site/delete/certification", { id: id })
      .then((res) => res);
  }
  saveSiteCertification(data: any) {
    return commonDataAccess
      .postData("site/save/certification", data)
      .then((res) => res?.data);
  }
  getSiteCertification(caItemId: any) {
    return commonDataAccess
      .getData("site/get/certification", { caItemId: caItemId })
      .then((res) => res);
  }
  getUpcomingAuditListAsync = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData("site/upcoming-audits", parameters);
  };
  getOverdueAuditListAsync = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData("site/overdue-audits", parameters);
  };
  getSiteAuditHistory(caItemId: any) {
    return commonDataAccess
      .getData("site/get/siteaudithistory", { caItemId: caItemId })
      .then((res) => res);
  }
  getSiteDocuments = async (params: { caItemId: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "site/get/siteDocuments/" + params,
      {}
    );
    return result;
  };
  saveSiteDocuments(data: any, caItemId: any) {
    return commonDataAccess.postFormData("site/save/siteDocuments", data, {
      caItemId: caItemId,
    });
  }
  deleteSiteDocuments = async (params: { id: number | bigint }) => {
    return commonDataAccess.deleteData("site/delete/siteDocuments/" + params);
  };
  getSiteNoteInfo(caItemId: any) {
    return commonDataAccess
      .getData("site/get/SiteNoteInfo", { caItemId: caItemId })
      .then((res) => res);
  }
  saveSiteNoteInfo(data: any) {
    return commonDataAccess
      .postData("site/save/SiteNoteInfo", data)
      .then((res) => res?.data);
  }
  saveSiteSupplierInfo(data: any) {
    return commonDataAccess
      .postData("site/save/SiteSupplierInfo", data)
      .then((res) => res?.data);
  }
  getSiteSupplierInfo(caItemId: any) {
    return commonDataAccess
      .getData("site/get/SiteSupplierInfo", { caItemId: caItemId })
      .then((res) => res);
  }
  saveSiteContactInfo(data: any) {
    return commonDataAccess
      .postData("site/save/SiteContactInfo", data)
      .then((res) => res?.data);
  }
  getSiteContactInfo(caItemId: any) {
    return commonDataAccess
      .getData("site/get/SiteContactInfo", { caItemId: caItemId })
      .then((res) => res);
  }
  getListasync = async (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };
    return await commonDataAccess.getData("site/getall", parameters);
  };

  deleteSite(ids: any) {
    return commonDataAccess
      .deleteData("site/delete", { ids: ids })
      .then((res) => res);
  }
  getSitePermissionInfo(caItemId: any) {
    return commonDataAccess
      .getData("site/get/permission", { ncItemId: caItemId })
      .then((res) => res);
  }
  saveSitePermissionInfo(data: any) {
    return commonDataAccess
      .postData("site/save/permission", data)
      .then((res) => res?.data);
  }
  getSiteBasicInfo = (caItemId: number) => {
    return commonDataAccess
      .getData("site/get/basicInfo", { ncItemId: caItemId })
      .then((res) => res);
  };
  saveSiteBasicInfo = (data) => {
    return commonDataAccess
      .postData("site/save/basicInfo", data)
      .then((res) => res?.data);
  };
  getSiteDateInfo = (caItemId: number) => {
    return commonDataAccess
      .getData("site/get/dateInfo", { ncItemId: caItemId })
      .then((res) => res);
  };
  saveSiteDateInfo = (data) => {
    return commonDataAccess
      .postData("site/save/dateInfo", data)
      .then((res) => res?.data);
  };
}

export default new SiteDataAccess();
